import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="25" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.427 9.29l-3.88 3.88-3.88-3.88a.996.996 0 10-1.41 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59a.996.996 0 000-1.41c-.39-.38-1.03-.39-1.42 0z" fill="#444" /></svg>;